import { render, staticRenderFns } from "./AudioMsgWrap.vue?vue&type=template&id=6968f662&scoped=true&"
import script from "./AudioMsgWrap.vue?vue&type=script&lang=js&"
export * from "./AudioMsgWrap.vue?vue&type=script&lang=js&"
import style0 from "./AudioMsgWrap.vue?vue&type=style&index=0&id=6968f662&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6968f662",
  null
  
)

export default component.exports